export interface LabelRect { left: number; top: number; right: number; bottom: number }

/** Nearest available position, within the playable viewport and clear of every earlier label. */
export function placeLabel(x: number, y: number, width: number, height: number, bounds: LabelRect, occupied: LabelRect[]): LabelRect | null {
  if (width > bounds.right - bounds.left || height > bounds.bottom - bounds.top) return null;
  const clampX = (left: number) => Math.max(bounds.left, Math.min(left, bounds.right - width));
  const clampY = (top: number) => Math.max(bounds.top, Math.min(top, bounds.bottom - height));
  const left = clampX(x - width / 2), top = clampY(y - height);
  const candidates = [{ left, top }];
  // Obstacles supply exact adjacent candidates; a small grid covers packed groups without pushing another label away.
  for (const rect of occupied) candidates.push({ left, top: clampY(rect.bottom + 6) }, { left, top: clampY(rect.top - height - 6) }, { left: clampX(rect.right + 6), top }, { left: clampX(rect.left - width - 6), top });
  for (let yy = bounds.top; yy + height <= bounds.bottom; yy += height + 6)
    for (let xx = bounds.left; xx + width <= bounds.right; xx += width + 6) candidates.push({ left: xx, top: yy });
  candidates.sort((a, b) => (a.left - left) ** 2 + (a.top - top) ** 2 - (b.left - left) ** 2 - (b.top - top) ** 2);
  for (const candidate of candidates) {
    const rect = { ...candidate, right: candidate.left + width, bottom: candidate.top + height };
    if (occupied.every(other => rect.right + 5 <= other.left || rect.left >= other.right + 5 || rect.bottom + 5 <= other.top || rect.top >= other.bottom + 5)) return rect;
  }
  return null;
}
